import React, { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ErrorMessage from '../../components/ErrorMessage';
import FormLabel from '../../components/FormLabel';
import SimpleButton from '../../components/SimpleButton';
import Spacer from '../../components/Spacer';
import { IApplicationState } from '../../store';
import { sweepWorkRegisterDraftUpdate, sweepsSaveWorkRegisterRequest } from '../../store/sweeps/slice';
import { ISweepTime, } from '../../store/sweeps/types';
import { Container } from './styles';
import FormArea from '../../components/FormArea';
import FormData from '../../components/FormData';
import { useMatch } from 'react-router';

const WorkRegisterForm: React.FC = (props) => {
    const route = useMatch('/sweep-work-register/:idSweep/:idRegister/form');

    const routeRegister = useMatch('/sweep-work-register/:idSweep/form');

    const { t } = useTranslation();

    const idSweep = routeRegister?.params.idSweep;

    const idRegister = route?.params.idRegister;

    const sweep = useSelector((state: IApplicationState) => state.sweeps.data.find(sweep => sweep.id === idSweep))

    const workRegister = sweep?.times.find(workRegister => workRegister.id === idRegister);

    const sweeps = useSelector((state: IApplicationState) => state.sweeps);

    const dispatch = useDispatch();

    const [isLoaded, setIsLoaded] = useState(false);

    const editingRegister = sweeps.draftWorkSweepRegister;

    const setEditingRegister = useCallback((register: ISweepTime) => {
        dispatch(sweepWorkRegisterDraftUpdate(register))
    }, [dispatch])

    useEffect(() => {
        if (workRegister && !isLoaded) {
            setEditingRegister({
                ...workRegister,
                error: undefined
            });
            setIsLoaded(true)
        }
    }, [workRegister, isLoaded, setEditingRegister]);

    if (!editingRegister) {
        return (
            <Container>
                <h1>{t("pages.sweeps.register_not_found_form")}</h1>
            </Container>
        );
    }

    return (
        <Container>
            <h1>{t("pages.sweeps.create_work_register")}</h1>

            <FormLabel>{t("pages.sweeps.work_register_begining")}</FormLabel>
            <Spacer size={5} />
            <FormData
                onChange={(date) => {
                    setEditingRegister({
                        ...editingRegister,
                        beginingAt: date,
                    });
                }}
            />

            <FormLabel>{t("pages.sweeps.work_register_ending")}</FormLabel>
            <Spacer size={5} />
            <FormData
                onChange={(date) => {
                    setEditingRegister({
                        ...editingRegister,
                        endingAt: date,
                    });
                }}
            />

            <Spacer size={20} />

            <FormLabel>{t("pages.sweeps.work_register_observation")}</FormLabel>
            <Spacer size={5} />
            <FormArea
                value={String(editingRegister?.observation || "") || ""}
                onChangeText={(text) => {
                    setEditingRegister({
                        ...editingRegister,
                        observation: text
                    })
                }}
            />

            <Spacer size={20} />

            <SimpleButton
                prependIcon='save'
                color='primary'
                disabled={editingRegister.isSaving}
                onClick={() => {
                    dispatch(sweepsSaveWorkRegisterRequest(editingRegister))
                }}>
                {editingRegister.isSaving ? `${t("common.buttons.saving")}...` : t("common.buttons.save")}
            </SimpleButton>

            <Spacer size={20} />

            {editingRegister?.error &&
                <ErrorMessage>{editingRegister.error.message}</ErrorMessage>
            }
        </Container>

    );
}

export default WorkRegisterForm;